import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConstructionHelmet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconConstructionHelmet"><Path d="M14 3H10V14.5H14V3Z" fill="currentColor"/><Path d="M3 12.5C3 8.77087 5.26806 5.57145 8.5 4.20593V14.5H3V12.5Z" fill="currentColor"/><Path d="M21 14.5V12.5C21 8.77087 18.7319 5.57145 15.5 4.20593V14.5H21Z" fill="currentColor"/><Path d="M2 16H22V20H2V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConstructionHelmet;
